<template>
  <div id="image-rights">
    <Header
      v-if="team && team.club && parseInt(team.club.top) == 1"
      :page="'image-rights'"
      :title_one="'image-rights'"
      :action_one="'params.download_collectives'"
      @download="getLinkTeam()"
    ></Header>
    <Header v-else :page="'image-rights'" :title_one="'image-rights'"></Header>

    <div class="descriptions">
      <p><span v-html="$t('descriptions.image-rights')"></span></p>
    </div>

    <div class="search">
      <div>
        <input
          type="text"
          v-model="search"
          :placeholder="$t('params.search')"
        />
      </div>
    </div>

    <v-data-table
      class="dataTable"
      :headers="headers"
      :items="persons"
      :search="search"
      :no-data-text="''"
      :no-results-text="''"
      :hideActions="true"
    >
      <template v-slot:items="props">
        <td>{{ props.item.dni }}</td>
        <td>{{ props.item.name }}</td>
        <td>{{ props.item.surname }}</td>
        <td>{{ $t("titles." + props.item.type) }}</td>
        <td>
          <template v-if="parseInt(props.item.image_right_status) == 0">
            <button @click="sendLink(props.item.id, props.item.type)">
              {{ $t("image_right.send_link") }}
            </button>
            <button @click="copyLink(props.item.id, props.item.type)">
              {{ $t("image_right.copy_link") }}
            </button>
          </template>
          <template v-else>
            <button
              class="done"
              @click="openLink(props.item.id, props.item.type)"
            >
              {{ $t("image_right.status.signed") }}
            </button>
          </template>
        </td>
      </template>
    </v-data-table>

    <v-snackbar
      v-model="snackbar"
      :timeout="timeout"
      :top="true"
      :vertical="false"
    >
      {{ text }}
      <v-btn
        style="color: red; font-weight: bold; font-size: 16px"
        flat
        @click="snackbar = false"
      >
        X
      </v-btn>
    </v-snackbar>

    <ErrorPopup
      @close="closePopup()"
      @input="closePopup()"
      :dialog="dialog"
      :message="message"
    ></ErrorPopup>
  </div>
</template>

<script>
/* global ObjectToArray */
import i18n from '@/i18n'
import Header from '@/components/layout/Header'
import ErrorPopup from '@/components/ui/ErrorPopup.vue'

export default {
  name: 'ImageRights',
  components: {
    Header,
    ErrorPopup
  },
  data () {
    return {
      snackbar: false,
      dialog: false,
      message: false,
      text: 'HOLAAAA',
      timeout: 0,
      persons: [],
      headers: [
        {
          text: i18n.t('params.dni'),
          value: 'dni',
          sortable: true
        },
        {
          text: i18n.t('params.name'),
          value: 'name',
          sortable: true
        },
        {
          text: i18n.t('params.surname'),
          value: 'dni',
          sortable: true
        },
        {
          text: i18n.t('params.type'),
          value: 'type',
          sortable: true
        },
        {
          text: i18n.t('params.status'),
          sortable: false
        }
      ],
      search: '',
      team: {}
    }
  },
  computed: {
    event () {
      return this.$store.getters['getCurrentEvent']()
    },

    user () {
      return this.$store.getters['user/getUser']
    }
  },
  methods: {
    load () {
      var self = this

      // load information for admin user
      if (this.user.admin) {
        this.$store
          .dispatch('club/loadClubEvent', {
            club_id: this.user.club_id,
            event_id: this.user.event_id
          })
          .then(function () {})
      }

      // get players and staff
      this.$store
        .dispatch('team/loadTeam', { team_id: this.$route.params.team_id })
        .then(function () {
          // get information
          self.team = { ...self.$store.getters['team/getTeam'] }

          // create array
          let players = self.team.players
          let staff = self.team.staff

          // loop players
          for (let i in players) {
            players[i].type = 'player'
          }

          // loop staff
          for (let i in staff) {
            staff[i].type = 'staff'
          }

          // save players and staff in the same array
          self.persons = [...ObjectToArray(players), ...ObjectToArray(staff)]
        })
    },

    closePopup () {
      this.dialog = false
    },

    download (id, type) {
      if (type === 'player') {
        window.open(
          process.env.VUE_APP_API_URL +
            'player/' +
            id +
            '/imagerights/' +
            this.user.event_id +
            '/' +
            this.user.language +
            '/' +
            localStorage.token
        )
      }

      if (type === 'staff') {
        window.open(
          process.env.VUE_APP_API_URL +
            'staff/' +
            id +
            '/imagerights/' +
            this.user.event_id +
            '/' +
            this.user.language +
            '/' +
            localStorage.token
        )
      }
    },

    sendLink (id, type) {
      var self = this
      this.$store
        .dispatch('person/sendImageRight', {
          event_id: this.event.id,
          id: id,
          type: type,
          lang: this.user.language,
          team_id: this.team.team.id
        })
        .then((response) => {
          if (!response) {
            self.dialog = true
            self.message = i18n.t('image_right.messages.no_valid_email')
          } else {
            self.dialogImageRight = false
            this.text = i18n.t('image_right.messages.link_sended')
            this.snackbar = true
          }
        })
    },

    copyLink (id, type) {
      var self = this
      this.$store
        .dispatch('person/getLinkImageRight', {
          event_id: this.event.id,
          id: id,
          type: type,
          lang: this.user.language,
          team_id: this.team.team.id
        })
        .then((response) => {
          if (!response) {
            self.dialog = true
            self.message = i18n.t('image_right.messages.no_valid_email')
          } else {
            navigator.clipboard.writeText(response)
            this.snackbar = true
            this.text = i18n.t('image_right.messages.link_copied')
          }
          //   alert("Se ha copiado el link en el portapapeles");
        })
    },

    openLink (id, type) {
      var self = this
      this.$store
        .dispatch('person/getLinkImageRight', {
          event_id: this.event.id,
          id: id,
          type: type,
          lang: this.user.language
        })
        .then((response) => {
          if (!response) {
            self.dialog = true
            self.message = i18n.t('image_right.messages.no_valid_email')
          } else {
            window.open(response, '_blank')
          }
          //   alert("Se ha copiado el link en el portapapeles");
        })
    },

    getLinkTeam (id, type) {
      this.$store
        .dispatch('team/getLinkImageRight', {
          event_id: this.event.id,
          id: this.team.team.id,
          lang: this.user.language
        })
        .then((response) => {
          navigator.clipboard.writeText(response)
          this.snackbar = true
          this.text = i18n.t('image_right.messages.link_copied')
          //   alert("Se ha copiado el link en el portapapeles");
        })
    },

    generalDownload () {
      window.open(
        process.env.VUE_APP_API_URL +
          'team/' +
          this.team.team.id +
          '/imagerights/' +
          this.user.event_id +
          '/' +
          this.user.language +
          '/' +
          localStorage.token
      )
    }
  },
  watch: {
    $route: 'load'
  },
  created () {
    this.load()
  }
}
</script>

<style lang="scss" scoped>
#image-rights {
  background-color: #fff;
  margin: 0;
  padding: 0;
  height: 100%;

  .descriptions,
  .search {
    margin-top: 25px;
  }

  .search {
    width: 100%;
    display: inline-block;
    input {
      @include background(
        $image: img("magnify.svg"),
        $position: right 5px center,
        $size: 22px
      );
      padding: 10px 30px 10px 15px;
      border: 1px solid $secondary-color;
      outline: none;
      font-size: 11pt;
      border-radius: 3px;
      color: $dark-color;
      float: right;

      &::placeholder {
        color: $dark-color;
        opacity: 0.5;
      }
    }
  }

  .dataTable {
    > div {
      table {
        text-align: center;
        width: 100%;
        margin: 20px auto 0;
        border-radius: 5px;
        overflow: visible;
        min-width: 600px;

        th {
          background-color: $secondary-color;
          background-color: #ddd;
        }
        td,
        th {
          border: 1px solid $secondary-color;
          padding: 12px;
          text-align: left;
          border-left: 0;
          border-right: 0;
          min-width: 60px;
        }

        tr:nth-child(even) {
          background-color: #f7f7f7;
        }

        th {
          font-weight: normal;
          border: 0 solid $secondary-color;
          color: $main-color;
          color: #333;
          padding: 20px;
          text-transform: uppercase;
          width: 20%;
        }

        th.column[role="columnheader"] {
          padding: 20px 12px 12px 12px !important;
        }

        td {
          button {
            padding: 0;
            margin: 0;
            width: 100%;
            height: 100%;
            min-width: 40px;
            max-width: 120px;
            outline: none;
            cursor: pointer;
            font-size: 8pt;
            font-family: Speedee-Bold;
            // margin-top: 5px;
            border-radius: 3px;
            border: 1px solid black;
            text-transform: uppercase;
            transition: all 0.5s;
            background-color: transparent;
            color: #c55c00;
            height: 30px;
            padding: 0;
            border: 1px solid #fc8926;
            font-family: Roboto-Bold;
            font-size: 14px;
            transition: background-color 0.5s ease;
            margin: 0 5px;

            &:hover {
              background-color: #fc8a2623 !important;
            }
            &.done {
              border: 1px solid #13c040 !important;
              background-color: #13c040 !important;
              color: #fff !important;
              &:hover {
                background-color: #05621d !important;
              }
            }
          }
        }
      }
    }
  }

  .v-snack__content {
    background-color: #ee7e1c;
    color: #000;
    font-family: "Roboto-Light";
    font-size: 16px;
  }
}
</style>
